import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M28 22a2 2 0 00-2 2v2H6v-2a2 2 0 00-4 0v3.5A2.5 2.5 0 004.5 30h23a2.5 2.5 0 002.5-2.5V24a2 2 0 00-2-2z"/><path d="M18.17 3a3 3 0 00-4.34 0L8.54 8.64a2 2 0 002.92 2.72L14 8.64V21a2 2 0 004 0V8.64l2.54 2.72a2 2 0 102.92-2.72z"/>';
export var UploadSVG = function UploadSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
UploadSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(UploadSVG);